import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { DownloadType } from "./download-type.model";

@Injectable()
export class DownloadTypeService extends CrudService {
  getRootUrl(): string {
    return "download-types";
  }

  save(downloadType: DownloadType) {
    return super.save(downloadType);
  }

  saveMultiple(downloadTypes: Array<DownloadType>) {
    return super.saveMultiple(downloadTypes);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/download-types/shared/download-type.service.ts